export const attributionMap = "<b><a href='/impressum' >Info & Imprint</a> </b>&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors ";
// + " - Reachability by  <a href='http://targomo.com'>Targomo</a>";
